import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/browser';


Sentry.init({
    dsn: window.sentryDsn,
    environment: window.sentryEnvironment,
    integrations: [new BrowserTracing()],
    tracesSampleRate: window.sentryTraceSampleRate,
    initialScope: (scope) => {
        if(window.authenticated){
            scope.setUser({
                id: window.user.id,
                username: window.user.username,
                email: window.user.email
            });
            scope.setTag("user_login", window.user.username);
        }
        return scope;
    },
});

// Expose for non-module scripts (e.g. ready.js bundle) that need captureMessage.
window.Sentry = Sentry;


if (window.replayStart) {
    const url = new URL(window.appUrl);

    var replay = new Sentry.Replay({
        networkDetailAllowUrls: [window.location.origin, '/', `^${url.protocol}//${url.host}(/.*)?$`],
        networkRequestHeaders: ["Cache-Control"],
        networkResponseHeaders: ["Referrer-Policy"],
        networkCaptureBodies: true,
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        mask: ['[data-private]'],
    });

    Sentry.getCurrentHub().getClient().addIntegration(replay);

    if (replay.getReplayId() === undefined) {
        replay.start();
    }
}
